// To submit email and mail preferences
var AriesComponent = require('libs/aries-component');
/*
 * Main class
 */
var MailPreferences = AriesComponent.extend({
  /**
   * This function is used to prepare customized XHR payload required by Play
   * @returns {Stringified JSON} Returns stringified JSON
   */
  getXHRPayload: function _getXHRPayload(){
    var _self = this;
    var preferences = _self.preferences;
    var checkboxes = _self.$el.find('input[type="checkbox"]');
    var payload = {
      'sessionToken': _self.getSessionToken(),
      'context': {}
    };
    payload.context[preferences] = {
      'subscriptions' : []
    };
    // Additional flag for Unsubscribe Flow
    var isUnsubscribe = _self.$el.find(".l-unsubscribe-email").is(":visible"); 
    checkboxes.each(function(index,checkbox){
      payload.context[preferences].subscriptions.push({
        'type': checkbox.attributes['data-type'] ? checkbox.attributes['data-type'].value : '',
		'method': checkbox.attributes['data-method'] ? checkbox.attributes['data-method'].value : '',
        'subscribed': isUnsubscribe ? !checkbox.checked:checkbox.checked
      });
      /*if(preferences === 'communicationPreferences') {
        payload.context[preferences].subscriptions[index].method = checkbox.attributes['data-method'].value;
      }*/
    });
    if($('#emeaMarketingConsent').val()){
      payload.context[preferences].emeaMarketingConsent = true;
    }
    if($("#js-personal-preferences-input-korean-id").val() == "true"){
      payload.context[preferences].communcationPreferenceKR = true;
    }
    else {
      payload.context[preferences].communcationPreferenceKR = false;
    }
    if($("#js-personal-preferences-input-id").val() == "2"){
      payload.context[preferences].personalizedMarketingConsent = true;
    }
    else if($("#js-personal-preferences-input-id").val() == "0"){
      payload.context[preferences].personalizedMarketingConsent = false;
    }
    if(_self.$el.find('#unsubscribeAll').val())
    payload.context[preferences].country = _self.$el.find('.js-countries-list').val();
    payload.context[preferences].unsubscribeAll = _self.$el.find('#unsubscribeAll').val();
    
    if(preferences === 'communicationPreferences') {
     payload.context[preferences].preferredLanguage  = _self.$el.find('.js-preferred-language').val();
     type ="";
     $.each(payload.context[preferences].subscriptions, function(i, el){
      if (this.type == type){
        payload.context[preferences].subscriptions.splice(i, 2);
      }
    });
    } else {
      payload.context[preferences].email  = _self.$el.find('.l-email input').val();
    }
    return JSON.stringify(payload);
  }
});

module.exports = MailPreferences;
